import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "2500",
  width: "2500",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "6 6 41 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        d: "M14.906 6h23.188C43.013 6 47 9.89 47 14.689V37.31C47 42.11 43.013 46 38.094 46H14.906C9.987 46 6 42.11 6 37.311V14.69C6 9.89 9.987 6 14.906 6z",
        fill: "#ff4100"
      }),
      _createElementVNode("path", {
        d: "M40.995 21.11a.918.918 0 0 1-.807 1.012l-5.334.57a1.613 1.613 0 0 0-1.441 1.63c.016.961.324 1.894.883 2.675l5.083 7.107a.93.93 0 0 1-.2 1.287l-1.223.903a.898.898 0 0 1-1.267-.204l-3.3-4.613a1.369 1.369 0 0 0-1.826-.372 4.044 4.044 0 0 0-1.597 1.828l-3.735 8.52a.902.902 0 0 1-1.175.477l-.022-.01-1.381-.624a.927.927 0 0 1-.47-1.195l.01-.022 2.25-5.136a1.534 1.534 0 0 0-.651-1.952 4.339 4.339 0 0 0-2.59-.534l-9.042.966a.91.91 0 0 1-.997-.82l-.158-1.527a.918.918 0 0 1 .807-1.013l5.65-.603c.729-.078 1.278-.7 1.266-1.433a4.161 4.161 0 0 0-.776-2.35l-5.58-7.802a.93.93 0 0 1 .2-1.287l1.223-.902a.898.898 0 0 1 1.267.204l3.283 4.59a1.65 1.65 0 0 0 2.2.448 4.872 4.872 0 0 0 1.924-2.203l3.585-8.178a.902.902 0 0 1 1.175-.477l.022.01 1.381.624c.45.204.657.735.47 1.195l-.01.022-2.26 5.156a1.607 1.607 0 0 0 .684 2.045c.824.464 1.772.66 2.713.56l8.611-.92a.91.91 0 0 1 .997.82zM27 29a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "#fff"
      })
    ], -1)
  ]))]))
}
export default { render: render }